import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Icon } from './icon';
import { SearchService } from './search.service';

@Component({
  selector: 'app-not-found',
  imports: [RouterLink, Icon],
  template: `
    <section class="min-h-[85vh] flex flex-col items-center justify-center text-center px-6 py-32 relative overflow-hidden">
      <div class="absolute inset-0 opacity-[0.04] flex items-center justify-center pointer-events-none">
        <span class="route-code text-[40vw] leading-none">SL</span>
      </div>
      <div class="relative z-10">
        <span class="route-code text-vermilion text-sm">ROUTE 404</span>
        <h1 class="text-6xl md:text-8xl font-serif leading-[0.9] tracking-tight mt-6 mb-6">
          Off the <span class="italic font-light text-ink/35">map.</span>
        </h1>
        <p class="text-ink/55 max-w-md mx-auto mb-10 text-lg leading-relaxed">
          This page isn't on any itinerary we've plotted. Let's get you back to a route
          that exists.
        </p>
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <a routerLink="/" class="btn-vermilion justify-center">Back to Home</a>
          <a routerLink="/tours" class="btn-outline justify-center">Browse Tours</a>
          <button type="button" (click)="search.open()" class="btn-outline justify-center">
            <app-icon name="search" [size]="16" /> Search
          </button>
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class NotFound {
  search = inject(SearchService);
}
